module.exports = __webpack_public_path__ + "static/assets/2a91744114199ec839868819d77ef08b.png";